import React, { useState } from 'react';
import { norm } from '../utils/buscar';

/**
 * Input con autocompletar propio (no el <datalist> nativo, que falla en algunos
 * navegadores): al escribir muestra un desplegable con las coincidencias
 * (sin tildes) para seleccionar con clic. Mismo comportamiento en toda la app.
 */
export default function AutocompleteInput({ value, onChange, placeholder, suggestions = [], style, max = 8 }) {
  const [open, setOpen] = useState(false);
  const q = norm(value);
  const matches = suggestions.filter(o => !q || norm(o).includes(q)).slice(0, max);
  return (
    <div style={{ position: 'relative' }}>
      <input style={style} placeholder={placeholder} value={value}
             onChange={e => { onChange(e.target.value); setOpen(true); }}
             onFocus={() => setOpen(true)}
             onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && matches.length > 0 && (
        <div style={s.box}>
          {matches.map((o, j) => (
            <div key={j} style={s.item} onMouseDown={() => { onChange(o); setOpen(false); }}>{o}</div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  box: { position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 60, background: '#0f172a', border: '1px solid #334155', borderRadius: 8, maxHeight: 240, overflowY: 'auto', boxShadow: '0 12px 32px rgba(0,0,0,.5)' },
  item: { padding: '8px 11px', fontSize: 13, color: '#e2e8f0', cursor: 'pointer', borderBottom: '1px solid #1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
};
